import { AsyncPipe } from '@angular/common';
import {
  AfterContentInit,
  Component,
  Input,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  AaNgModule,
  DisplayStrategy,
  ICellDefinition,
  IColumnHeaderDefinition,
  IRowDefinition,
  ISTCourse,
  ObjectPropertyDisplayStrategy,
} from 'aa-ng';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-courses',
  imports: [AaNgModule, AsyncPipe],
  template: `
    @if (!useBodyWidget) {
      <div class="course-header flex row">
        <h3>Recent Courses</h3>
        <button type="button" class="primary" (click)="showMore = !showMore">
          {{ showMore ? 'Hide' : 'Show' }} Details
        </button>
      </div>
      @for (course of _courses; track course) {
        <div class="course-container">
          <div class="course-title">{{ course.title }}</div>
          @if (showMore) {
            <div>{{ course?.prefix }} {{ course.code }}</div>
          }
          @if (showMore) {
            <div>{{ course.courseTerm?.shortName }}</div>
          }
          @if (showMore) {
            <div>{{ course.description }}</div>
          }
        </div>
      }
    } @else {
      <aa-grid-virtual-scroll
        #grid
        [rowDefinition]="_rowDefinitions"
        [columnHeaderDefinitions]="_columnHeaderDefinitions"
        [records]="_courses"
        [inputScrollEvent]="scrollEvent$ | async"
        [pageSize]="pageSize"
      >
      </aa-grid-virtual-scroll>
    }

    <ng-template #bodyWidget>
      <aa-grid-virtual-scroll
        #grid
        [rowDefinition]="_rowDefinitions"
        [columnHeaderDefinitions]="_columnHeaderDefinitions"
        [records]="_courses"
        [inputScrollEvent]="scrollEvent$ | async"
        [pageSize]="pageSize"
      >
      </aa-grid-virtual-scroll>
    </ng-template>

    <ng-template #termHeader><span>Term</span></ng-template>
    <ng-template #courseHeader><span>Course</span></ng-template>

    <ng-template #courseCell let-course>
      <h3 class="title">{{ course.title }}</h3>
      <table>
        @if (!!course.code) {
          <tr>
            <td>{{ course?.prefix }}{{ course.code }}</td>
          </tr>
        }
        @if (course.description?.length) {
          <tr>
            <td>Description:</td>
            <td>{{ course.description }}</td>
          </tr>
        }
      </table>
    </ng-template>
  `,
  styleUrls: ['./courses.component.scss'],
})
export class CoursesComponent implements AfterContentInit {
  showMore: boolean;
  _courses: ISTCourse[] = [];
  _columnHeaderDefinitions: IColumnHeaderDefinition[];
  _rowDefinitions: IRowDefinition<ISTCourse>;

  @Input() set courses(courses: ISTCourse[]) {
    this._courses = courses;
  }

  @Input() useBodyWidget = false;
  @Input() pageSize = 20;
  @Input() scrollEvent$ = new BehaviorSubject<Event>(null);

  @ViewChild('termHeader', { static: true })
  termHeaderTemplate: TemplateRef<null>;
  @ViewChild('courseHeader', { static: true })
  courseHeaderTemplate: TemplateRef<null>;
  @ViewChild('courseCell', { static: true })
  courseCellTemplate: TemplateRef<null>;

  constructor() {
    this.showMore = false;
  }

  ngAfterContentInit(): void {
    this._columnHeaderDefinitions = [
      { displayStrategy: new DisplayStrategy(this.termHeaderTemplate) },
      {
        displayStrategy: new DisplayStrategy(this.courseHeaderTemplate),
        width: '10fr',
      },
    ];

    const cellDefinitions: ICellDefinition<ISTCourse>[] = [
      {
        displayStrategy: new ObjectPropertyDisplayStrategy<ISTCourse>(
          (course) => course.courseTerm?.shortName || '',
        ),
      },
      {
        displayStrategy: new ObjectPropertyDisplayStrategy<ISTCourse>(
          this.courseCellTemplate,
        ),
      },
    ];

    this._rowDefinitions = { cellDefinitions };
  }
}
